// extracted by mini-css-extract-plugin
export default {"itemNewsEvent":"newsAndEvents_itemNewsEvent__PzfSR","title":"newsAndEvents_title__I4BL3","date":"newsAndEvents_date__O0iHP"};